
import { Create, SimpleForm, TextInput, DateInput, NumberInput } from 'react-admin';

export const Tbl_teamCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <NumberInput source="legaId" />
            <TextInput source="nome" />
            <TextInput source="note" />
            <NumberInput source="flVisibile" />
            <NumberInput source="flAttivo" />
            <NumberInput source="flAnnullato" />
            <NumberInput source="ordinamento" />
            <DateInput source="createdAt" />
            <DateInput source="updatedAt" />
        </SimpleForm>
    </Create>
);
            